import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./progress.sass";
import { useSelector } from "react-redux";
import image from "../image";

export default function Progress() {
  const { i18n, t } = useTranslation();
  const statusData = useSelector((state) => state.user.statusData);
  const [completePercent, setCompletePercent] = useState(0);

  const [courseData, setCourseData] = useState({});

  useEffect(() => {
    console.log(`output->statusData`, statusData);
    if (statusData === null) return;
    // 尋找statusData.user_progress底下progress非0的項目，然後計算完成百分比
    const completeCount = statusData.user_progress.filter(
      (item) => item.progress !== 0,
    ).length;
    setCompletePercent(
      Math.round((completeCount / statusData.user_progress.length) * 100),
    );
  }, [statusData]);

  useEffect(() => {
    // 將多語系資料拉進來放到courseData
    let data = t(`course.tab`, { returnObjects: true }).map((item) => item);
    data = data.map((item) => {
      let completeCount = 0;
      item.card = item.card.map((card) => {
        // 用card.course_no去找statusData.user_progress裡面的progress，將progress放到card裡面
        const progress = statusData.user_progress.find(
          (progress) => progress.course_no === card.course_no,
        );
        card.progress = progress ? progress.progress : 0;
        if (card.progress !== 0) completeCount++;
        return card;
      });
      item.completeCount = completeCount;
      return item;
    });
    console.log(`output->courseData`, data);
    setCourseData(data);
  }, [i18n.language, statusData]); // 依賴於當前語言環境

  const [starmove, setStarmove] = useState(0);
  useEffect(() => {
    const windowScroll = () => {
      setStarmove(((window.scrollY * 1.285) / 1920) * -100);
    };
    window.addEventListener("scroll", windowScroll);

    return () => {
      window.removeEventListener("scroll", windowScroll);
    };
  }, []);

  return (
    <section className="progress-section">
      <div className="wrapper">
        <div className="bg">
          <div className="main">
            <figure className="title">
              {/* 判斷不同語系載入不同圖片 */}
              {i18n.language === "zh" ? (
                <img src={image.progressTitleZhSrc} alt="" />
              ) : i18n.language === "cn" ? (
                <img src={image.progressTitleCnSrc} alt="" />
              ) : i18n.language === "jp" ? (
                <img src={image.progressTitleJpSrc} alt="" />
              ) : (
                <img src={image.progressTitleEnSrc} alt="" />
              )}
              {/* <img src={image.progressTitleSrc} alt="" /> */}
            </figure>
            <div className="info">
              <div className="bg">
                <div className="percent">
                  <p>
                    {completePercent}
                    <span>%</span>
                  </p>
                </div>
                <div className="remind">
                  {t("myBear.percentRemind", {
                    completePercent,
                    uncompletePercent: 100 - completePercent,
                  })}
                </div>
                <div className="description">
                  {completePercent === 0
                    ? t("myBear.courseEmptyDescription")
                    : completePercent === 100
                      ? t("myBear.courseSuccessDescription")
                      : t("myBear.courseDescription")}
                </div>
              </div>
            </div>
            <div className="category-box">
              {/* 這裡要用courseData來render */}
              {courseData.length
                ? courseData.map((course, index) => {
                    return (
                      <div className="category-item" key={index}>
                        <figure className="planet">
                          <img src={image[`planetSrc0${index + 1}`]} alt="" />
                        </figure>
                        <div className="title-box">
                          <div className="category-title">
                            {t(`myBear.courseTitle0${index + 1}`)}
                            <br />({course.completeCount}/{course.card.length})
                          </div>
                          {/* 點擊後要跳轉到課程的頁面，同時帶上餐數 */}
                          <Link to={`/course?class=${index}`}>
                            <div className="btn">
                              <figure>
                                <img
                                  src={image[`categoryBtn0${index + 1}`]}
                                  alt=""
                                />
                              </figure>
                              <p className="txt">
                                {t(`myBear.courseBtn0${index + 1}`)}
                              </p>
                            </div>
                          </Link>
                        </div>
                        <div className="class-info">
                          <figure>
                            <img
                              src={image[`categoryBg0${index + 1}`]}
                              alt=""
                            />
                          </figure>
                          {course.card.map((card, cardIndex) => {
                            return (
                              <div
                                className={`item ${
                                  card.progress !== 0 ? "complete" : ""
                                }`}
                                key={cardIndex}
                              >
                                {card.title}
                                {card.progress !== 0
                                  ? ` (${t("myBear.complete")})`
                                  : ""}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })
                : ""}
            </div>
          </div>
        </div>
      </div>
      <figure
        className="icon01"
        style={{
          transform: `translateY(${starmove * 0.2}vh)`,
        }}
      >
        <img src={image.icon01} alt="" />
      </figure>
      <figure
        className="icon02"
        style={{
          transform: `translateY(${starmove * 0.2}vh)`,
        }}
      >
        <img src={image.icon02} alt="" />
      </figure>
      <figure
        className="icon03"
        style={{
          transform: `translateY(${starmove * 0.2}vh)`,
        }}
      >
        <img src={image.icon03} alt="" />
      </figure>
      <figure
        className="icon04"
        style={{
          transform: `translateY(${starmove * 0.2}vh)`,
        }}
      >
        <img src={image.icon04} alt="" />
      </figure>
    </section>
  );
}
